<div class="mx-4 mt-4 mb-0">
  <div>
    <h4 class="font-weight-bolder">Oops!</h4>
    <p>
      {{errorMessage}}
    </p>
  </div>
  <button (click)="goBack()" *ngIf="!backDisabled" class="btn btn-dark  btn-lg float-right">Go back</button>
</div>